type LogLevel = "DEBUG" | "LOG" | "INFO" | "WARN" | "ERROR";

const logLevels: Record<LogLevel, number> = {
  DEBUG: 0,
  LOG: 1,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

export const configConsoleLogLevel = (logLevel: LogLevel): void => {
  const configLevel: LogLevel =
    logLevel && logLevel in logLevels ? (logLevel as LogLevel) : "INFO";

  const currentLevel = logLevels[configLevel];
  const noop = (): void => {};

  if (currentLevel > logLevels.DEBUG) console.debug = noop;

  if (currentLevel > logLevels.INFO) {
    console.log = noop;
    console.info = noop;
  }

  if (currentLevel > logLevels.WARN) console.warn = noop;
  if (currentLevel > logLevels.ERROR) console.error = noop;
};
